// extracted by mini-css-extract-plugin
module.exports = {"hintsAdd":"styles_hintsAdd__2ZaeV","hintsAddHeader":"styles_hintsAddHeader__3rN3V","title":"styles_title__hfpxW","hintsBody":"styles_hintsBody__XRidS","hint":"styles_hint__3OBXJ"};